export default class BaseDeviseController {
    constructor() {
        this.resource_name = $('body').data('resource-name');
    }

    setPasswordVisibility() {
        $('.js-toggle-password').unbind('click', this.togglePassword).click(this.togglePassword);
    }

    togglePassword(e) {
        e.preventDefault();

        const toggleButton = $(e.currentTarget);
        const input = toggleButton.closest('.position-relative').find('input[type="password"], input[type="text"]').first();

        if (!input.length) {
            return;
        }

        const icon = toggleButton.find('.password-toggle-icon');
        const isHidden = input.attr('type') === 'password';

        input.attr('type', isHidden ? 'text' : 'password');

        if (icon.length) {
            icon.toggleClass('eye-icon', !isHidden);
            icon.toggleClass('eye-off-icon', isHidden);
        }

        input.trigger('focus');
    }
}